import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './translations/en.json';
import lv from './translations/lv.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            lv: { translation: lv },
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        lng: undefined,
    });

export default i18n;